<div class="sidebar-header flex items-center justify-between gap-2 px-1 py-2">
  <img src="/assets/testlogo.png" alt="PIMS Logo" class="h-[42px] w-[42px]" />
  <button
    class="bg-primary hover-bg-primary-hover h-[28px] w-[28px] cursor-pointer rounded-full"
    (click)="hideSidebar()">
    <svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 24 24" class="ltr:block rtl:hidden">
      <path
        class="stroke-bg-white"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m14 7l-5 5l5 5"
        stroke-width="1" />
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 24 24" class="ltr:hidden rtl:block">
      <path
        class="stroke-bg-white"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m10 7l5 5l-5 5"
        stroke-width="1" />
    </svg>
  </button>
</div>

<ul class="border-border-card mt-1 flex w-full flex-col gap-2 border-b-[2px] pb-3">
  <li>
    <a routerLink="/admin" class="sidebar-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M13 9V3h8v6zM3 13V3h8v10zm10 8V11h8v10zM3 21v-6h8v6zm2-10h4V5H5zm10 8h4v-6h-4zm0-12h4V5h-4zM5 19h4v-2H5zm4-2" />
      </svg>
      <span i18n="@@adminSidebarDashboard">Dashboard</span>
    </a>
  </li>

  <li
    *hasScope="[
      SCOPES.CATEGORIES.READ_ALL,
      SCOPES.SUB_CATEGORIES.READ_ALL,
      SCOPES.COMPANIES.READ_ALL,
      SCOPES.SUPPLIERS.READ_ALL,
      SCOPES.REJECTION_REASONS.READ_ALL,
      SCOPES.UNDELIVERED_REASONS.READ_ALL,
      SCOPES.PARTIALLY_DELIVERED_REASONS.READ_ALL,
      SCOPES.CANCELLATION_REASONS.READ_ALL,
    ]">
    <button class="sidebar-item w-full" (click)="goToLookups($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 28 28">
        <path
          fill="currentColor"
          d="M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25h-6.775l-1.5-1.5H17v-5h-4.076a6.5 6.5 0 0 0-.422-1.5H17v-6h-6v3.81a6.5 6.5 0 0 0-1.5-1.078V11h-5v2.313a6.5 6.5 0 0 0-1.5.709zM18.5 18.5v5h2.75a2.25 2.25 0 0 0 2.25-2.25V18.5zm5-1.5v-6h-5v6zm0-10.25a2.25 2.25 0 0 0-2.25-2.25H18.5v5h5zM17 4.5h-6v5h6zm-7.5 0H6.75A2.25 2.25 0 0 0 4.5 6.75V9.5h5zM6.5 25c1.248 0 2.4-.416 3.323-1.117l2.897 2.897a.75.75 0 1 0 1.06-1.06l-2.897-2.897A5.5 5.5 0 1 0 6.5 25m0-1.5a4 4 0 1 1 0-8a4 4 0 0 1 0 8"
          stroke-width="0.5"
          stroke="currentColor" />
      </svg>
      <span i18n="@@adminSidebarLookups">Lookups</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isLookupsOpen()">
        <path fill="currentColor" d="m7 10l5 5l5-5z" />
      </svg>
    </button>
    <ul class="submenu flex flex-col" [class.open]="isLookupsOpen()">
      <li class="text-primary text-[14px]" *hasScope="SCOPES.CATEGORIES.READ_ALL">
        <a
          routerLink="/admin/categories"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M2 2h9v9H2zm15.5 0C20 2 22 4 22 6.5S20 11 17.5 11S13 9 13 6.5S15 2 17.5 2m-11 12l4.5 8H2zM19 17h3v2h-3v3h-2v-3h-3v-2h3v-3h2z" />
          </svg>
          <span i18n="@@adminSidebarCategories">Categories</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]" *hasScope="SCOPES.SUB_CATEGORIES.READ_ALL">
        <a routerLink="/admin/subcategories" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M19 5v2h-4V5zM9 5v6H5V5zm10 8v6h-4v-6zM9 17v2H5v-2zM21 3h-8v6h8zM11 3H3v10h8zm10 8h-8v10h8zm-10 4H3v6h8z" />
          </svg>
          <span i18n="@@adminSidebarSubcategories">Subcategories</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]" *hasScope="SCOPES.COMPANIES.READ_ALL">
        <a
          routerLink="/admin/companies"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path fill="currentColor" d="M13 3v6h8V3m-8 18h8V11h-8M3 21h8v-6H3m0-2h8V3H3z" />
          </svg>
          <span i18n="@@adminSidebarCompanies">Companies</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]" *hasScope="SCOPES.SUPPLIERS.READ_ALL">
        <a
          routerLink="/admin/suppliers"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M18 18.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m1.5-9l1.96 2.5L17 13.5V9.5M6 18.5A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5z" />
          </svg>
          <span i18n="@@adminSidebarSuppliers">Suppliers</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]" *hasScope="SCOPES.UNDELIVERED_REASONS.READ_ALL">
        <a
          routerLink="/admin/undelivered-reasons"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <span i18n="@@adminSidebarUndeliveredReasons">Undelivered Reasons</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]">
        <a
          routerLink="/admin/partially-package-reasons"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <span i18n="@@adminSidebarPartiallyPackageReasons">Partially Package Reasons</span>
        </a>
      </li>
      <li *hasScope="SCOPES.PARTIALLY_DELIVERED_REASONS.READ_ALL" class="textTabsColor text-[14px]">
        <a
          routerLink="/admin/partially-delivered-reasons"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <span i18n="@@adminSidebarPartiallyDeliveredReasons">Partially Delivered Reasons</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]" *hasScope="SCOPES.CANCELLATION_REASONS.READ_ALL">
        <a routerLink="/admin/cancellation" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <span i18n="@@adminSidebarCancellationReasons">Cancellation Reasons</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]">
        <a
          routerLink="/admin/rejection-reasons"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <span i18n="@@adminSidebarRejectionReasons">Rejection Reasons</span>
        </a>
      </li>
      <li class="textTabsColor text-[14px]">
        <a
          routerLink="/admin/instapay-Accounts"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <app-instapay-icon />
          <span i18n="@@instapayAccount">InstaPay Account</span>
        </a>
      </li>
      <a routerLink="/admin/bank-account" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
        <app-bank-icon />
        <span i18n="@@bankAccounts">Bank Accounts</span>
      </a>
    </ul>
  </li>

  <li *hasScope="[SCOPES.PRODUCTS.READ_ALL, SCOPES.STOCK.READ_ALL, SCOPES.GLOBAL_ATTRIBUTES.READ]">
    <button class="sidebar-item w-full" (click)="goToProducts($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M16.2 3.5c-1-1-2.3-1.5-3.5-1.5s-2.6.5-3.5 1.5L3.4 9.1c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l5.7-5.7c1.9-1.9 1.9-5.1 0-7m-1.4 5.6L12 11.9L8.4 8.4L4 12.8c0-.8.2-1.7.9-2.3l5.7-5.7c.5-.5 1.3-.8 2-.8s1.5.3 2.1.8c1.2 1.3 1.2 3.1.1 4.3m4.8-2c0 .8-.2 1.5-.4 2.3c1 1.2 1 3-.1 4.1l-2.8 2.8l-1.5-1.5l-2.8 2.8c-1.3 1.3-3.1 2-4.8 2c.2.3.4.6.7.9c2 2 5.1 2 7.1 0l5.7-5.7c2-2 2-5.1 0-7.1c-.5-.2-.8-.4-1.1-.6" />
      </svg>
      <span i18n="@@adminSidebarProducts">Products</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isProductsOpen()">
        <path fill="currentColor" d="m7 10l5 5l5-5z" />
      </svg>
    </button>
    <ul class="submenu flex flex-col" [class.open]="isProductsOpen()">
      <li class="text-primary text-[14px]" *hasScope="SCOPES.PRODUCTS.READ_ALL">
        <a
          routerLink="/admin/products"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M16.2 3.5c-1-1-2.3-1.5-3.5-1.5s-2.6.5-3.5 1.5L3.4 9.1c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l5.7-5.7c1.9-1.9 1.9-5.1 0-7m-1.4 5.6L12 11.9L8.4 8.4L4 12.8c0-.8.2-1.7.9-2.3l5.7-5.7c.5-.5 1.3-.8 2-.8s1.5.3 2.1.8c1.2 1.3 1.2 3.1.1 4.3m4.8-2c0 .8-.2 1.5-.4 2.3c1 1.2 1 3-.1 4.1l-2.8 2.8l-1.5-1.5l-2.8 2.8c-1.3 1.3-3.1 2-4.8 2c.2.3.4.6.7.9c2 2 5.1 2 7.1 0l5.7-5.7c2-2 2-5.1 0-7.1c-.5-.2-.8-.4-1.1-.6" />
          </svg>
          <span i18n="@@adminSidebarProducts">Products</span>
        </a>
      </li>
      <li class="text-primary text-[14px]" *hasScope="SCOPES.STOCK.READ_STOCKS">
        <a routerLink="/admin/stock" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path fill="currentColor" d="M20 13V4H4v9H2v2h2v5h16v-5h2v-2zM6 18v-3h12v3zm12-5H6V6h12z" />
          </svg>
          <span i18n="@@adminSidebarStocks">Stock</span>
        </a>
      </li>
      <li class="text-primary text-[14px]" *hasScope="SCOPES.GLOBAL_ATTRIBUTES.READ">
        <a routerLink="/admin/attributes" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <path
                d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12.001 2.5c4.478 0 6.717 0 8.108 1.391S21.5 7.521 21.5 12c0 4.478 0 6.717-1.391 8.109c-1.391 1.39-3.63 1.39-8.109 1.39c-4.478 0-6.717 0-8.109-1.39c-1.39-1.392-1.39-3.63-1.39-8.11Z" />
              <path stroke-linejoin="round" d="M2.5 8h19" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M11 17h6M7 17h1m3-4h6M7 13h1" />
            </g>
          </svg>
          <span i18n="@@adminSidebarAttributes">Attributes</span>
        </a>
      </li>
    </ul>
  </li>

  <li *hasScope="[SCOPES.OFFERS.READ_ALL, SCOPES.BUNDLES.READ_ALL]">
    <button class="sidebar-item w-full" (click)="goToPromotions($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16">
        <path
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          d="m5.5 10.5l5-5m-2.682-4l1.768 1.06l2.053.181l.807 1.897L14 5.99L13.538 8L14 10.009l-1.554 1.353l-.807 1.897l-2.053.181l-1.768 1.06l-1.767-1.06l-2.054-.181l-.806-1.897l-1.555-1.353L2.098 8l-.462-2.009l1.555-1.353l.806-1.897l2.054-.181zM7 6.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0Zm4 3.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0Z" />
      </svg>
      <span i18n="@@adminSidebarPromotions">Promotions</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isPromotionsOpen()">
        <path fill="currentColor" d="m7 10l5 5l5-5z" />
      </svg>
    </button>
    <ul class="submenu flex flex-col" [class.open]="isPromotionsOpen()">
      <li class="text-primary text-[14px]" *hasScope="SCOPES.OFFERS.READ_ALL">
        <a routerLink="/admin/offers" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="m21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42M13 20.01L4 11V4h7v-.01l9 9z" />
            <circle cx="6.5" cy="6.5" r="1.5" fill="currentColor" />
          </svg>
          <span i18n="@@adminSidebarOffers">Offers</span>
        </a>
      </li>
      <li class="text-primary text-[14px]" *hasScope="SCOPES.BUNDLES.READ_ALL">
        <a routerLink="/admin/bundles" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 36 36">
            <path
              fill="currentColor"
              d="m32.43 8.35l-13-6.21a1 1 0 0 0-.87 0l-15 7.24a1 1 0 0 0-.57.9v16.55a1 1 0 0 0 .6.92l13 6.19a1 1 0 0 0 .87 0l15-7.24a1 1 0 0 0 .57-.9V9.25a1 1 0 0 0-.6-.9M19 4.15l10.93 5.22l-5.05 2.44l-10.67-5.35Zm-2 11.49L6 10.41l5.9-2.85l10.7 5.35ZM5 12.13l11 5.27v14.06L5 26.2Zm13 19.32V17.36l13-6.29v14.1Z" />
          </svg>
          <span i18n="@@adminSidebarBundles">Bundles</span>
        </a>
      </li>
    </ul>
  </li>

  <li>
    <button class="sidebar-item w-full" (click)="goToInvoices($event)">
      <app-document-check-icon />
      <span i18n="@@adminSidebarInvoices">Invoices and Payments</span>
      <app-chevron-bottom-icon
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isInvoicesOpen()" />
    </button>

    <ul class="submenu flex flex-col" [class.open]="isInvoicesOpen()">
      <li class="tabs-text text-[14px]">
        <a
          routerLink="/admin/invoices"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <app-file-text-icon />
          <span i18n="@@adminSidebarInvoiceAdmin">Invoices</span>
        </a>
      </li>

      <!-- <li class="text-[14px] tabs-text"> -->
      <li *hasScope="SCOPES.PAYMENT_REQUESTS.READ_ALL" class="tabs-text text-[14px]">
        <a
          routerLink="/admin/payment-requests"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z" />
          </svg>
          <span i18n="@@adminSidebarPaymentRequests">Payment Requests</span>
        </a>
      </li>
      <li class="tabs-text text-[14px]">
        <a
          routerLink="/admin/account-statement"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <app-invoice-icon />
          <span i18n="@@adminSidebarAccountStatement">Account Statement</span>
        </a>
      </li>
    </ul>
  </li>

  <li *hasScope="SCOPES.ADMIN_CART.READ_ALL">
    <a routerLink="/admin/cart" class="sidebar-item" routerLinkActive="active">
      <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M17 18a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63l-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1zm6 16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z" />
      </svg>
      <span i18n="@@adminSidebarCart">Cart</span>
    </a>
  </li>

  <li *hasScope="SCOPES.ORDERS.READ_ALL">
    <button class="sidebar-item w-full" (click)="gotoOrders($event)">
      <app-document-order-icon />
      <span i18n="@@adminSidebarOrders">Orders</span>
      <app-chevron-bottom-icon class="ms-auto transition-transform duration-300" [class.rotate-180]="isOrdersOpen()" />
    </button>
    <ul class="submenu flex flex-col" [class.open]="isOrdersOpen()">
      <li class="tabs-text text-[14px]">
        <a
          routerLink="/admin/orders"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <app-document-order-icon class="scale-90" />
          <span i18n="@@adminSidebarOrders">Orders</span>
        </a>
      </li>
      <li class="tabs-text text-[14px]">
        <a
          routerLink="/admin/returns-requests"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12.5 8c-2.65 0-5.05 1-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88c3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8" />
          </svg>
          <span i18n="@@userSidebarReturns">Returns</span>
        </a>
      </li>
    </ul>
  </li>

  <li *hasScope="SCOPES.USERS.READ_ALL">
    <button class="sidebar-item w-full" (click)="goToUserManagement($event)">
      <app-user-management-icon />
      <span i18n="@@adminSidebarUserManagement">User Management</span>
      <app-chevron-bottom-icon
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isUserManagementOpen()" />
    </button>

    <ul class="submenu flex flex-col" [class.open]="isUserManagementOpen()">
      <li class="text-primary text-[14px]">
        <a
          routerLink="/admin/user-management"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <app-user-management-icon class="scale-90" />
          <span i18n="@@adminSidebarUsers">Users</span>
        </a>
      </li>

      <li class="text-primary text-[14px]">
        <a routerLink="/admin/departments" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <app-department-icon class="scale-90" />
          <span i18n="@@adminSidebarDepartments">Departments</span>
        </a>
      </li>
    </ul>
  </li>

  <li *hasScope="[SCOPES.PHARMACIES.READ_ALL, SCOPES.PHARMACIES.READ_ALL_APPROVED]">
    <button class="sidebar-item w-full" (click)="goToPharmacies($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
        <g fill="currentColor">
          <path
            d="M9 5c0-.406.152-.747.356-.884c.15-.1.713-.336 2.19.416a1 1 0 0 0 .908-1.782c-1.723-.877-3.16-1-4.21-.296C7.248 3.121 7 4.274 7 5H5c-.552 0-1.008.45-.919.996a6.3 6.3 0 0 0 .528 1.683c.402.85.991 1.62 1.734 2.27a8.2 8.2 0 0 0 2.596 1.518c.66.24 1.354.4 2.061.478V15h2v-3.055a9 9 0 0 0 1.934-.433a2 2 0 0 1-.934 1.22v2.142c1.725-.444 3-2.01 3-3.874a1 1 0 0 0-.111-.459q.405-.274.768-.591a7 7 0 0 0 1.734-2.271a6.4 6.4 0 0 0 .528-1.683C20.009 5.45 19.552 5 19 5z" />
          <path
            d="M9.5 13h.5v2h-.5a.5.5 0 0 0 0 1h4.338a2.162 2.162 0 0 1 1.14 4H17v2H7v-2h4a1 1 0 0 1 .183-.577a1 1 0 0 1 .523-.379l2.183-.728a.162.162 0 0 0-.051-.316H9.5a2.5 2.5 0 0 1 0-5" />
        </g>
      </svg>
      <span i18n="@@adminSidebarPharmaciesManagement">Pharmacies Management</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isPharmaciesOpen()">
        <path fill="currentColor" d="m7 10l5 5l5-5z" />
      </svg>
    </button>

    <ul class="submenu flex flex-col" [class.open]="isPharmaciesOpen()">
      <li class="text-primary text-[14px]" *hasScope="SCOPES.PHARMACIES.READ_ALL">
        <a routerLink="/admin/pharmacies" class="sidebar-submenu flex items-center gap-2" routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <g fill="currentColor">
              <path
                d="M9 5c0-.406.152-.747.356-.884c.15-.1.713-.336 2.19.416a1 1 0 0 0 .908-1.782c-1.723-.877-3.16-1-4.21-.296C7.248 3.121 7 4.274 7 5H5c-.552 0-1.008.45-.919.996a6.3 6.3 0 0 0 .528 1.683c.402.85.991 1.62 1.734 2.27a8.2 8.2 0 0 0 2.596 1.518c.66.24 1.354.4 2.061.478V15h2v-3.055a9 9 0 0 0 1.934-.433a2 2 0 0 1-.934 1.22v2.142c1.725-.444 3-2.01 3-3.874a1 1 0 0 0-.111-.459q.405-.274.768-.591a7 7 0 0 0 1.734-2.271a6.4 6.4 0 0 0 .528-1.683C20.009 5.45 19.552 5 19 5z" />
              <path
                d="M9.5 13h.5v2h-.5a.5.5 0 0 0 0 1h4.338a2.162 2.162 0 0 1 1.14 4H17v2H7v-2h4a1 1 0 0 1 .183-.577a1 1 0 0 1 .523-.379l2.183-.728a.162.162 0 0 0-.051-.316H9.5a2.5 2.5 0 0 1 0-5" />
            </g>
          </svg>
          <span i18n="@@adminSidebarPharmacyRequests">Pharmacy Requests</span>
        </a>
      </li>

      <li class="text-primary text-[14px]" *hasScope="SCOPES.PHARMACIES.READ_ALL_APPROVED">
        <a
          routerLink="/admin/approved-pharmacies"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="m17.275 20.25l3.475-3.45l-1.05-1.05l-2.425 2.375l-.975-.975l-1.05 1.075zM6 9h12V7H6zm12 14q-2.075 0-3.537-1.463T13 18t1.463-3.537T18 13t3.538 1.463T23 18t-1.463 3.538T18 23M3 22V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v6.675q-.475-.225-.975-.375T19 11.075V5H5v14.05h6.075q.125.775.388 1.475t.687 1.325L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5zm3-5h5.075q.075-.525.225-1.025t.375-.975H6zm0-4h7.1q.95-.925 2.213-1.463T18 11H6zm-1 6.05V5z" />
          </svg>
          <span i18n="@@adminSidebarPharmacies">Pharmacies</span>
        </a>
      </li>
      <li class="text-primary text-[14px]">
        <a
          routerLink="/admin/pharmacy-segments"
          class="sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27z" />
          </svg>
          <span i18n="@@adminSidebarPharmacySegments">Pharmacy Segments</span>
        </a>
      </li>
    </ul>
  </li>
  <li
    *hasScope="[
      SCOPES.ROUTES.READ_ALL,
      SCOPES.ROUTES_INSTANCE.READ_ALL,
      SCOPES.ROUTES.REGION_TAB,
      SCOPES.ROUTES.PHARMACIES_TAB,
    ]">
    <button class="sidebar-item w-full" (click)="goToRoutes($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2 2a1 1 0 0 0-1 1v14c0 1.354.897 2.498 2.129 2.872a3 3 0 0 0 5.7.128h6.342a3 3 0 0 0 5.7-.128A3 3 0 0 0 23 17v-4a5 5 0 0 0-5-5h-4V3a1 1 0 0 0-1-1zm13.171 16H14v-8h4a3 3 0 0 1 3 3v4a1 1 0 0 1-.293.707a3 3 0 0 0-5.536.293m-9.878.293a1 1 0 1 1 1.414 1.414a1 1 0 0 1-1.414-1.414M17 19a1 1 0 1 1 2 0a1 1 0 0 1-2 0"
          clip-rule="evenodd" />
      </svg>
      <span i18n="@@adminSidebarRoutes">Routes</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isRoutesOpen()">
        <path fill="currentColor" d="m7 10l5 5l5-5z" />
      </svg>
    </button>

    <ul class="submenu flex flex-col" [class.open]="isRoutesOpen()">
      <li class="text-primary text-[14px]" *hasScope="SCOPES.ROUTES.READ_ALL">
        <a
          routerLink="/admin/routes"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M2 2a1 1 0 0 0-1 1v14c0 1.354.897 2.498 2.129 2.872a3 3 0 0 0 5.7.128h6.342a3 3 0 0 0 5.7-.128A3 3 0 0 0 23 17v-4a5 5 0 0 0-5-5h-4V3a1 1 0 0 0-1-1zm13.171 16H14v-8h4a3 3 0 0 1 3 3v4a1 1 0 0 1-.293.707a3 3 0 0 0-5.536.293m-9.878.293a1 1 0 1 1 1.414 1.414a1 1 0 0 1-1.414-1.414M17 19a1 1 0 1 1 2 0a1 1 0 0 1-2 0"
              clip-rule="evenodd" />
          </svg>
          <span i18n="@@adminSidebarRoutes">Routes</span>
        </a>
      </li>

      <li class="text-primary text-[14px]" *hasScope="SCOPES.ROUTES_INSTANCE.READ_ALL">
        <a
          routerLink="/admin/route-instances"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M19.5 19.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0Z" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2 12v5c0 .935 0 1.402.201 1.75a1.5 1.5 0 0 0 .549.549c.348.201.815.201 1.75.201m10 0h-5m5.5-2V9c0-1.414 0-2.121-.44-2.56C14.122 6 13.415 6 12 6h-1m4.5 2.5h1.801c.83 0 1.245 0 1.589.195c.344.194.557.55.984 1.262l1.699 2.83c.212.354.318.532.373.728c.054.197.054.403.054.816V17c0 .935 0 1.402-.201 1.75a1.5 1.5 0 0 1-.549.549c-.348.201-.815.201-1.75.201M7.85 7.85l-1.35-.9V4.7M2 6.5a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0" />
            </g>
          </svg>
          <span i18n="@@adminSidebarRouteInstances">Route Instances</span>
        </a>
      </li>
    </ul>
  </li>
  <li *hasScope="[SCOPES.SUPERADMIN.CITIES]">
    <button class="sidebar-item w-full" (click)="openSystemConfigs($event)">
      <app-gear-icon />
      <span i18n="@@adminSidebarSystemConfigs">System Configs</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        class="ms-auto transition-transform duration-300"
        [class.rotate-180]="isSystemConfigsOpen()">
        <path fill="currentColor" d="m7 10l5 5l5-5z" />
      </svg>
    </button>

    <ul class="submenu flex flex-col" [class.open]="isSystemConfigsOpen()">
      <li class="text-primary text-[14px]" *hasScope="SCOPES.SUPERADMIN.CITIES">
        <a
          routerLink="/admin/governorates"
          class="submenu-item sidebar-submenu flex items-center gap-2"
          routerLinkActive="active">
          <app-governorate-icon />
          <span i18n="@@governorates">Governorates</span>
        </a>
      </li>
    </ul>
  </li>
</ul>

<a
  routerLink="/admin/update-profile"
  class="sidebar-item mt-auto"
  routerLinkActive="active"
  *hasScope="SCOPES.USERS.UPDATE_DETAILS">
  <svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 640 512">
    <path
      fill="currentColor"
      d="M256.1 248a120 120 0 1 0 0-240a120 120 0 1 0 0 240m-29.7 56c-98.5 0-178.3 79.8-178.3 178.3c0 16.4 13.3 29.7 29.7 29.7h196.5l10.9-54.5c4.3-21.7 15-41.6 30.6-57.2l67.3-67.3c-28-18.3-61.4-28.9-97.4-28.9h-59.4zm105.9 162.9l-11.9 59.6c-.2.9-.3 1.9-.3 2.9c0 8 6.5 14.6 14.6 14.6c1 0 1.9-.1 2.9-.3l59.6-11.9c12.4-2.5 23.8-8.6 32.7-17.5l118.9-118.9l-80-80l-118.9 118.9c-8.9 8.9-15 20.3-17.5 32.7zm267.8-123c22.1-22.1 22.1-57.9 0-80s-57.9-22.1-80 0l-28.8 28.8l80 80z" />
  </svg>
  <span i18n="@@adminSidebarUpdateProfile">Update Profile</span>
</a>

<button
  class="bg-primary hover-bg-primary-hover mb-3 flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-md px-3 py-1.5 text-[14px] font-medium text-white"
  (click)="logout()">
  <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h6q.425 0 .713.288T12 4t-.288.713T11 5H5v14h6q.425 0 .713.288T12 20t-.288.713T11 21zm12.175-8H10q-.425 0-.712-.288T9 12t.288-.712T10 11h7.175L15.3 9.125q-.275-.275-.275-.675t.275-.7.7-.313t.725.288L20.3 11.3q.3.3.3.7t-.3.7l-3.575 3.575q-.3.3-.712.288t-.713-.313q-.275-.3-.262-.712t.287-.688z" />
  </svg>
  <span i18n="@@adminSidebarLogout">Logout</span>
</button>
